(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/parse-url-to-fragments.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/utils/parse-url-to-fragments.js'); "use strict";


const teamsDelimiter = '-vs-';
const uppercaseFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);
const parseUrlToFragments = url => {
  url = decodeURIComponent(url);
  let fragments;
  const [category, ...matches] = url.match(/([^\\/]+)/ig) || [];
  if (category === 'sports') {
    let [sport, league, date, teams] = matches;
    if (sport) {
      sport = uppercaseFirstLetter(sport.replace(/-/g, ' '));
    }
    if (league) {
      league = uppercaseFirstLetter(league.replace(/-/g, ' '));
    }
    if (teams && teams.indexOf(teamsDelimiter)) {
      teams = teams.split(teamsDelimiter).map(team => uppercaseFirstLetter(team.replace('-', ' ')));
    }

    fragments = {
      sport,
      league: league || '',
      teams: teams || []
    };
  }
  return fragments;
};
if (svs.isServer) {
  module.exports = parseUrlToFragments;
} else {
  svs.sportsbook.sbtech_api_impl.utils.parseUrlToFragments = parseUrlToFragments;
}
 })(window);